import React from 'react';
import Markdown from '../common/Markdown';

export default function LegalMarkdownPage({ title, markdown }) {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-xl shadow border border-gray-100 p-6 md:p-10">
        {title ? <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-6">{title}</h1> : null}
        <Markdown className="prose prose-slate max-w-none">{markdown}</Markdown>
      </div>
    </div>
  );
}


